import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ApiService,
    Request,
    Response,
    ResponseCode
} from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';

export enum EnrollmentStatus {
    UNKNOWN_ENROLLMENT_STATUS = 'UNKNOWN_ENROLLMENT_STATUS',
    ELIGIBLE = 'ELIGIBLE',
    INELIGIBLE = 'INELIGIBLE',
    INVITED = 'INVITED',
    USER_CREATED = 'USER_CREATED',
    ENROLLED = 'ENROLLED',
    TRANSFERRED = 'TRANSFERRED'
}
export interface SupplierEnrollment {
    enrollmentStatus: EnrollmentStatus;
    createdAt: Date;
}
export class BuyerRelationshipInfo {
    public relationshipKey?: string;
    public buyerPreferredName?: string;
    public buyerLegalName?: string;
    public buyerKey?: string;
    public buyerCompanyKey?: string;
    constructor(obj?: {
        relationshipKey?: string;
        buyerPreferredName?: string;
        buyerLegalName?: string;
        buyerKey?: string;
        buyerCompanyKey?: string;
    }) {
        if (obj != null) {
            this.relationshipKey =
                typeof obj.relationshipKey === 'undefined'
                    ? this.relationshipKey
                    : obj.relationshipKey;
            this.buyerPreferredName =
                typeof obj.buyerPreferredName === 'undefined'
                    ? this.buyerPreferredName
                    : obj.buyerPreferredName;
            this.buyerLegalName =
                typeof obj.buyerLegalName === 'undefined'
                    ? this.buyerLegalName
                    : obj.buyerLegalName;
            this.buyerKey = obj.buyerKey === 'undefined' ? this.buyerKey : obj.buyerKey;
            this.buyerCompanyKey =
                typeof obj.buyerCompanyKey === 'undefined'
                    ? this.buyerCompanyKey
                    : obj.buyerCompanyKey;
        }
    }
}

export class GetSupplierRelationshipForOperationsResponse extends Response {
    public relationshipKey?: string;
    public buyerKey?: string;
    public supplierKey?: string;
    public supplierCompanyKey?: string;
    public supplierLegalName?: string;
    public supplierPreferredName?: string;
    public active?: boolean;
    public eligible?: boolean;
    public supplierEnrollments?: SupplierEnrollment[];

    public relationshipDecayingFeeDailyRatePercent?: number;
    public buyerDecayingFeeDailyRatePercent?: number;
    public platformDecayingFeeDailyRatePercent?: number;

    public relationshipIneligibleDaysBeforeTerms?: number;
    public buyerIneligibleDaysBeforeTerms?: number;
    public platformIneligibleDaysBeforeTerms?: number;
    public defaultIneligibleDaysBeforeTerms?: number;

    public allSellerRelationships?: BuyerRelationshipInfo[];

    constructor(obj?: {
        code?: ResponseCode;
        message?: string;
        relationshipKey?: string;
        buyerKey?: string;
        supplierKey?: string;
        supplierCompanyKey?: string;
        supplierLegalName?: string;
        supplierPreferredName?: string;
        active?: boolean;
        eligible?: boolean;
        supplierEnrollments?: SupplierEnrollment[];

        relationshipDecayingFeeDailyRatePercent?: number;
        buyerDecayingFeeDailyRatePercent?: number;
        platformDecayingFeeDailyRatePercent?: number;

        relationshipIneligibleDaysBeforeTerms?: number;
        buyerIneligibleDaysBeforeTerms?: number;
        platformIneligibleDaysBeforeTerms?: number;
        defaultIneligibleDaysBeforeTerms?: number;

        allSellerRelationships?: BuyerRelationshipInfo[];
    }) {
        super(obj);
        if (obj != null) {
            this.relationshipKey =
                typeof obj.relationshipKey === 'undefined'
                    ? this.relationshipKey
                    : obj.relationshipKey;
            this.supplierKey =
                typeof obj.supplierKey === 'undefined' ? this.supplierKey : obj.supplierKey;
            this.supplierCompanyKey =
                typeof obj.supplierCompanyKey === 'undefined'
                    ? this.supplierCompanyKey
                    : obj.supplierCompanyKey;
            this.supplierLegalName =
                typeof obj.supplierLegalName === 'undefined'
                    ? this.supplierLegalName
                    : obj.supplierLegalName;
            this.supplierPreferredName =
                typeof obj.supplierPreferredName === 'undefined'
                    ? this.supplierPreferredName
                    : obj.supplierPreferredName;
            this.buyerKey = typeof obj.buyerKey === 'undefined' ? this.buyerKey : obj.buyerKey;
            this.active = typeof obj.active === 'undefined' ? this.active : obj.active;
            this.eligible = typeof obj.eligible === 'undefined' ? this.eligible : obj.eligible;
            this.allSellerRelationships =
                typeof obj.allSellerRelationships === 'undefined'
                    ? this.allSellerRelationships
                    : obj.allSellerRelationships;
            this.supplierEnrollments =
                typeof obj.supplierEnrollments === 'undefined'
                    ? this.supplierEnrollments
                    : obj.supplierEnrollments;
            this.relationshipDecayingFeeDailyRatePercent =
                typeof obj.relationshipDecayingFeeDailyRatePercent === 'undefined'
                    ? this.relationshipDecayingFeeDailyRatePercent
                    : obj.relationshipDecayingFeeDailyRatePercent;
            this.relationshipIneligibleDaysBeforeTerms =
                typeof obj.relationshipIneligibleDaysBeforeTerms === 'undefined'
                    ? this.relationshipIneligibleDaysBeforeTerms
                    : obj.relationshipIneligibleDaysBeforeTerms;
            this.platformDecayingFeeDailyRatePercent =
                typeof obj.platformDecayingFeeDailyRatePercent === 'undefined'
                    ? this.platformDecayingFeeDailyRatePercent
                    : obj.platformDecayingFeeDailyRatePercent;
            this.platformIneligibleDaysBeforeTerms =
                typeof obj.platformIneligibleDaysBeforeTerms === 'undefined'
                    ? this.platformIneligibleDaysBeforeTerms
                    : obj.platformIneligibleDaysBeforeTerms;
            this.defaultIneligibleDaysBeforeTerms =
                typeof obj.defaultIneligibleDaysBeforeTerms === 'undefined'
                    ? this.defaultIneligibleDaysBeforeTerms
                    : obj.defaultIneligibleDaysBeforeTerms;
            this.buyerDecayingFeeDailyRatePercent =
                typeof obj.buyerDecayingFeeDailyRatePercent === 'undefined'
                    ? this.buyerDecayingFeeDailyRatePercent
                    : obj.buyerDecayingFeeDailyRatePercent;
            this.buyerIneligibleDaysBeforeTerms =
                typeof obj.buyerIneligibleDaysBeforeTerms === 'undefined'
                    ? this.buyerIneligibleDaysBeforeTerms
                    : obj.buyerIneligibleDaysBeforeTerms;
        }
    }
}

export class GetSupplierRelationshipForOperationsRequest extends Request {
    public relationshipKey?: string;
    constructor(obj?: { relationshipKey?: string }) {
        super();
        if (obj != null) {
            this.relationshipKey =
                typeof obj.relationshipKey === 'undefined'
                    ? this.relationshipKey
                    : obj.relationshipKey;
        }
    }
}

@Injectable({ providedIn: 'root' })
export class GetSupplierRelationshipForOperationsService extends ApiService<
    GetSupplierRelationshipForOperationsRequest,
    GetSupplierRelationshipForOperationsResponse
> {
    public requestType = GetSupplierRelationshipForOperationsRequest;
    public responseType = GetSupplierRelationshipForOperationsResponse;
    public endpointName = 'operations/GetSupplierRelationshipForOperations';
    public serviceName = 'financing';
    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }
}
